
// Map unit types to their corresponding SVG files
export const UNIT_SVG_MAP = {
  "Inlet": "/unit_operations/InOut.svg",
  "Outlet": "/unit_operations/InOut.svg",
  "Reactor": "/unit_operations/ReactorGeneric.svg",
  "CSTR": "/unit_operations/CSTRReactor.svg",
  "Separator": "/unit_operations/VesselDishedEndsGeneric.svg",
  "Vessel": "/unit_operations/VesselDishedEndsGeneric.svg",
  "Heat Exchanger": "/unit_operations/ReactorGeneric.svg", // Using reactor as fallback
  "Pump": "/unit_operations/InOut.svg", // Using inlet/outlet as fallback
  "Compressor": "/unit_operations/InOut.svg", // Using inlet/outlet as fallback
  "Mixer": "/unit_operations/Mixer.svg" // Using vessel as fallback
} as const;

// Unit types derived from the SVG map keys
export type UnitType = keyof typeof UNIT_SVG_MAP;

// Default port configurations for units without explicit port definitions in SVG
export const DEFAULT_PORTS = {
  "Separator": {
    inputs: [{ id: "inlet-1", x: 0, y: 25.5 }],
    outputs: [
      { id: "outlet-1", x: 36, y: 15 },
      { id: "outlet-2", x: 36, y: 36 }
    ]
  },
  "Mixer": {
    inputs: [
      { id: "inlet-1", x: 0, y: 15 },
      { id: "inlet-2", x: 0, y: 36 }
    ],
    outputs: [{ id: "outlet-1", x: 51, y: 25.5 }]
  },
  "Heat Exchanger": {
    inputs: [{ id: "inlet-1", x: 0, y: 25.5 }],
    outputs: [{ id: "outlet-1", x: 51, y: 25.5 }]
  },
  "Pump": {
    inputs: [{ id: "inlet-1", x: 0, y: 25.5 }],
    outputs: [{ id: "outlet-1", x: 51, y: 25.5 }]
  },
  "Compressor": {
    inputs: [{ id: "inlet-1", x: 0, y: 25.5 }],
    outputs: [{ id: "outlet-1", x: 51, y: 25.5 }]
  }
};
